module.exports = __webpack_public_path__ + "img/MC-Logo-Color.aff9629.png";